import {createAction, createSelector} from '@reduxjs/toolkit';
import fp from 'lodash/fp';

export const DATA = 'DATA';
export const DIRECTORY = 'DIRECTORY';
export const USERINFO = 'USERINFO';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

//action creators
export const userinfo = createAction(USERINFO);
export const directory = createAction(DIRECTORY);
export const receiveData = createAction(DATA);
export const login = createAction(LOGIN);
export const logout = createAction(LOGOUT);

// selectors
export const selectUserinfo = fp.get('jsonapi.userinfo');
export const selectObject = path => fp.flow([
    fp.get('jsonapi.objects'),
    fp.get(path),
]);
export const selectDirectory = fp.get('jsonapi.directory');
export const selectAccessToken = fp.get('jsonapi.accessToken');

export const selectProviders = createSelector(
    selectObject('Provider'),
    fp.values
);

const initialState = {
    accessToken: null,
    userinfo: null,
    directory: null,
    objects: {},
}

const reduceObject = (state, data) => {
    const path = `objects.${data.type}.${data.id}`;
    return fp.set(path, data, state);
}


export default function(state=initialState, action) {
    const {type, payload} = action;
    switch(type) {
        case LOGIN: {
            return fp.set('accessToken', payload, state);
        }
        case LOGOUT:
            return {
                ...initialState,
                directory: state.directory,
            }
        case USERINFO: {
            return fp.set('userinfo', payload, state);
        }
        case DIRECTORY: {
            return fp.set('directory', payload, state);
        }
        case DATA: {
            if(payload.data && payload.data.type) {
                return reduceObject(state, payload.data);
            } 
            if(payload.included && payload.included.length) {
                let newState = state;
                fp.forEach(item => {
                    newState = reduceObject(newState, item);
                }, payload.included);
                return newState;
            }
            if(payload.data && payload.data.length) {
                let newState = state;
                fp.forEach(item => {
                    newState = reduceObject(newState, item);
                }, payload.data);
                return newState;
            }
            return state;
        }
        default: return state;
    }
}
